module.exports = __webpack_public_path__ + "img/gotowebinar.fe1b9726.png";